import {h, Fragment} from "preact"
import { useEffect, useRef, useState } from "preact/hooks";

export default function SortBy({ value, onChange, className, options }) {
    const [isOpen, setIsOpen] = useState(false);
    const sortRef = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sortRef.current && !sortRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', handleClickOutside);
        return () => document.removeEventListener('click', handleClickOutside);
    }, []);

    const handleToggle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsOpen(!isOpen);
    };

    const handleSelect = (option) => {
        onChange({ target: { value: option.value }});
        setIsOpen(false);
    };

    return (
        <div class="facet-filters sorting caption">
            <div class="facet-filters__field">
                <div class="select select-mobile">
                    <input name="sort_by" class="hidden" value={value} />
                    <div class="sc-sort" ref={sortRef}>
                        <p class="H-14">Sort</p>
                        <button 
                            type="button"
                            class={`sc-sort-toggle ${isOpen ? 'active' : ''}`}
                            onClick={handleToggle}
                        >
                            <span class="button-text">
                                {options.find(opt => opt.value === value)?.label || 'Featured'}
                            </span>
                            <span class={`arrow ${isOpen ? 'active' : ''}`}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                                    <path d="M12.2402 6.75L7.99759 10.9926L3.75495 6.75" stroke="#333333" />
                                </svg>
                            </span>
                        </button>
                        <ul 
                            class="sc-sort-menu" 
                            style={`display: ${isOpen ? 'block' : 'none'}`}
                        >
                            {options.map(option => (
                                <li 
                                    key={option.value}
                                    class={`sc-sort-item ${option.value === value ? 'active' : ''}`}
                                    onClick={() => handleSelect(option)}
                                    data-value={option.value}
                                >
                                    {option.label}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}